import $ from 'jquery';
/* expose jQuery for modules */
window.$ = $;
window.jQuery = $;

//import './fonts';
import mouse from './mouse';
import './main_menu';
import './footer';
import './filters';

import CaseStudiesSlider from './sliders/case-studies';
import CasesSlider from './sliders/cases';
import TestimonialsSlider from './sliders/testimonials';
import WhatWeOfferSlider from './sliders/whatWeOffer';
import './sliders/services-vertical';

import './animations/scroll-events';
import './animations/ghost';
import './animations/effects';

import './animations/home-page';
import './animations/portfolio-page';
import './animations/clients-page';
import './animations/services-page';
import './animations/services-category-page';
import './animations/services-single-page';
import './animations/contact-page';
import './animations/blog-page';
import './animations/single-page';
import './animations/about-page';
import './animations/active-icons';
import './animations/whatwedo';

import './plans';

    
$(document).ready(() => {

    mouse($);
    
    const caseStudiesSlider = new CaseStudiesSlider();
    caseStudiesSlider.init(); 
    const casesSlider = new CasesSlider();
    casesSlider.init(); 
    const testimonialsSlider = new TestimonialsSlider();
    testimonialsSlider.init(); 
    const whatWeOfferSlider = new WhatWeOfferSlider();
    whatWeOfferSlider.init(); 

});
    


